export enum ApolloEndpoints {
  sylvera = 'sylvera',
  sylveraContentful = 'sylveraContentful',
  contentful = 'contentful',
  mock = 'mock',
}
